/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import clsx from "clsx"
import { motion } from "framer-motion"
import type { Variants } from "framer-motion"
import React, { useContext } from "react"

import PageThemeContext from "../../page-theme/PageThemeContext"
import PageGrid from "../../PageGrid"
import { NavItem } from "../types/navigation"

import Submenu from "./Submenu"

interface INavButtonProps {
  navItem: NavItem
  activeIndex: number
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>
  index: number
  setNavOpen: any
  navOpen: boolean
  menuData: NavItem[]
  allowHover: boolean
}

const NavButton: React.FC<INavButtonProps> = ({
  navItem,
  activeIndex,
  setActiveIndex,
  setNavOpen,
  navOpen,
  index,
  menuData,
  allowHover,
}) => {
  const pageThemeContext = useContext(PageThemeContext)
  const activeClass = pageThemeContext.pageTheme.dark
    ? "lg:text-newblue-50"
    : "lg:text-gray-90"
  const inactiveClass = pageThemeContext.pageTheme.dark
    ? "lg:text-gray-2.5"
    : "lg:text-gray-60"

  // this custom transform template is needed because otherwise Framer will set a translateZ of 0 with the translateY,
  // this caused a rendering bug in Chrome.
  // To fix I'm defining a custom transform template,
  // see docs here https://www.framer.com/docs/component/###transformtemplate
  function template({ y = 0 }) {
    return `translateY(${y})`
  }

  const openMenuVariant: Variants = {
    open: {
      y: "0",
      position: "absolute",
      width: "912px",
      left: "calc(50% - 408px)",
      backgroundColor: pageThemeContext.pageTheme.bgColorHex,
      transition: {
        bounce: 0,
        type: "spring",
      },
    },
    close: {
      y: "0",
      position: "absolute",
      width: "912px",
      left: "calc(50% - 408px)",
      backgroundColor: pageThemeContext.pageTheme.bgColorHex,
      transition: {
        bounce: 0,
        type: "spring",
      },
    },
  }

  return (
    <div
      onMouseOver={() => {
        if (!allowHover) return
        setActiveIndex(index)
        setNavOpen(true)
      }}
      onFocus={() => {
        if (!allowHover) return
        setActiveIndex(index)
        setNavOpen(true)
      }}
      onMouseLeave={() => {
        setActiveIndex(null)
        setNavOpen(false)
      }}
      key={`${navItem.name + index}`}
    >
      <button
        type="button"
        className={clsx(
          index === activeIndex ? activeClass : inactiveClass,
          "heading2 lg:py-6 lg:px-8 lg:hover:text-newblue-50",
        )}
        tabIndex={0}
      >
        {navItem.name}
      </button>
      {/* This function is a bit hacky, but it shows the submenu for desktop of the same index */}
      {menuData.map((filteredMenuitem, i) =>
        i === index && i === activeIndex ? (
          <motion.div
            variants={openMenuVariant}
            transformTemplate={template}
            animate={navOpen ? "open" : "close"}
            exit="close"
            initial="close"
            key={filteredMenuitem.name}
          >
            <PageGrid className="py-8 px-24 relative z-30 box-shadow-4">
              {filteredMenuitem.sections.map((section) => (
                <Submenu
                  key={section.links[0].linkTo}
                  animate={{ opacity: 1 }}
                  initial={{ opacity: 0 }}
                  {...section}
                />
              ))}
            </PageGrid>
          </motion.div>
        ) : null,
      )}
    </div>
  )
}

export default NavButton
